// Copyright ID Business Solutions Ltd. 2024

import styled from 'styled-components';

export const ClearDataButtonWrapper = styled.div`
  margin-right: 10px;
`;
